import { Directive, Input, OnChanges, Optional } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';

// ng2-charts v5 usa o Input `type` (default: 'bar') e removeu/alterou o antigo `chartType`.
// Essa directive mantém compatibilidade com templates antigos:
// <canvas baseChart chartType="pie" ...>
@Directive({
  selector: 'canvas[baseChart][chartType]',
})
export class Ng2ChartsChartTypeCompatDirective implements OnChanges {
  @Input() chartType: any;

  constructor(@Optional() private baseChart?: BaseChartDirective) {}

  ngOnChanges(): void {
    if (!this.baseChart || !this.chartType) return;

    const nextType = this.chartType as any;
    const currentType = (this.baseChart as any).type;

    if (currentType === nextType) return;

    (this.baseChart as any).type = nextType;

    // `type` exige re-render no ng2-charts 5 (destroy + new Chart()).
    if (typeof (this.baseChart as any).render === 'function') {
      (this.baseChart as any).render();
      return;
    }
    if (typeof (this.baseChart as any).update === 'function') {
      (this.baseChart as any).update();
    }
  }
}


